import { LoadingState } from "types";

export type BrandsState = {
  loading: LoadingState;
  brands: string[];
};
export const initialBrandsState: BrandsState = {
  loading: LoadingState.idle,
  brands: [],
};
